import { Trans } from 'react-i18next';
import { ReactComponent as LinkTo } from '../../../assets/svg/LinkTo.svg';
import { translit1 } from '../../../components/common';
import { useLanguage } from '../../../hooks';
import { Adverts, Polls } from '../../../services/content_v1';


interface WelcomeBottomProps {
    polls: Polls[],
    adverts: Adverts[],
}

function WelcomeBottom({ polls, adverts }: WelcomeBottomProps) {
    const lang = useLanguage();

    return (
        <section className="welcome-bottom">
            {polls.length > 0 && <div className="welcome-bottom__item _poll">
                <div className="welcome-bottom__item-header">
                    <div className="welcome-bottom__item-header-name">
                        <Trans>cms:POLLS</Trans>
                    </div>
                    <div className="welcome-bottom__item-header-link">
                        {/* <Link to={user ? '/polls' : '/public-polls'}>
                            <Trans>All polls</Trans><LinkTo />
                        </Link> */}
                        <a href={`/${lang}/public-polls`}>
                            <Trans>All polls</Trans><LinkTo />
                        </a>
                    </div>
                </div>
                <div className="welcome-bottom__item-body">
                    {polls.map((poll) => <p key={poll.id} className="welcome-bottom__item-poll">
                        {/* TODO XXX */}
                        <a href={`/${lang}/public-polls/${poll.id}_${translit1(poll.title) || '_'}`}>
                            {poll.title}
                        </a>
                    </p>)}
                </div>
            </div>}
            {(adverts.length || 0) > 0 && <div className="welcome-bottom__item _ann">
                <div className="welcome-bottom__item-header">
                    <div className="welcome-bottom__item-header-name">
                        <Trans>cms:ADVERTS</Trans>
                    </div>
                    <div className="welcome-bottom__item-header-link">
                        {/* <Link to={user ? '/adverts' : '/public-adverts'}>
                            <Trans>All adverts</Trans><LinkTo />
                        </Link> */}
                        <a href={`/${lang}/public-adverts`}>
                            <Trans>All adverts</Trans><LinkTo />
                        </a>
                    </div>
                </div>
                <div className="welcome-bottom__item-body">
                    {adverts.map((adv) => (
                        <p key={adv.id} className="welcome-bottom__item-ann">
                            {/* TODO XXX */}
                            <a href={`/${lang}/public-adverts/${adv.id}_${translit1(adv.title) || '_'}`}>
                                {adv.title}
                                {/* <br />
                                {adv.contacts} */}
                            </a>
                        </p>
                    ))}
                </div>
            </div>}
        </section>
    );
}

export default WelcomeBottom;